<!--suppress ALL -->

<template>
	<tr>
		<td class="text-center">
			{{ update.content }}
		</td>
		<td class="text-center">
			{{ update.created_at }}
		</td>
		<td class="text-center">
			{{ update.heb_date }}
		</td>
		<td class="text-center">
			<img
				v-if="update.type == 'square'"
				class="image-preview"
				:src="update.img"
			>
		</td>
		<td class="text-center">
			{{ typePrint }}
		</td>
		<td class="text-center">
			{{ update.active? "מוצג":"לא מוצג" }}
		</td>
		<td>
			<edit-btn @click="onEdit" />
			<remove-btn />
		</td>
	</tr>
</template>

<script>

import { types } from "src/store/modules/Update.module";
import RemoveBtn from "src/scaffoldings/RemoveBtn";
import EditBtn from "src/scaffoldings/EditBtn";
import RowMixin from "src/mixins/RowMixin";

export default {
	name: "UpdateRow",
	components: { EditBtn, RemoveBtn },
	props: {
		update: { required: true },
	},
	mixins: [new RowMixin(types, "update")],
	data () {
		return {};
	},
	computed: {
		typePrint () {
			let label = "";

			switch (this.update.type) {
			case "square":
				label = "תמונה";
				break;
			case "run":
				label = "רצות";
				break;
			}
			return label;
		},
	},
	methods: {
		doRemove () {
			this.$store.dispatch(types.REMOVE, this.update).then(() => {
			});
		},
		onEdit () {
			this.$emit("edit", this.update);
		},
	},
};
</script>

<style>

</style>
